export const frConfig = {
    taxOfficeName: 'Tax Authority',
    deliveryTaxOfficeQuestionTag: 'TAX',
    searchPlaceholder: "Search taxpayers using taxpayer/spouse names, Atlas ID or GTS ID...",
    taxId: "Numéro fiscal",
    kExplorerViewer: true,
};
